import axiosInstance from '../../../config/axiosInstance';
import { UpdateImageValidation } from "../View/Validation/UpdateImageValidation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault();
  

    const formErrors = UpdateImageValidation(formData);
   
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");

            // Create a FormData object
            const formDataToSend = new FormData();

            // Append form data fields
            formDataToSend.append('ClientID', CompanyID);
            formDataToSend.append('UserID', UserID);

            // Append other fields from formData
            Object.keys(formData).forEach(key => {
                if (key !== 'File') { // Skip the File key, we will handle it separately
                    formDataToSend.append(key, formData[key]);
                }
            });

            // Append the file if it exists
            if (formData.File) {
                formDataToSend.append('File', formData.File);
            }

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const response = await axiosInstance.post(`/Part/CreatePartDocument`, formDataToSend, config);
            return response.data.message;
        } catch (error) {
            console.error('Error posting data:', error);
        }
    }
};


export { handleChange, handleSubmit };
